
    exports.AnalagousStrategy = require('./theory/AnalagousStrategy');
    exports.colorTheoryRegistry = require('./theory/colorTheoryRegistry');
    //keep it uppercase also
    exports.ColorTheoryRegistry = exports.colorTheoryRegistry;
    exports.ComplementaryStrategy = require('./theory/ComplementaryStrategy');
    exports.CompoundTheoryStrategy = require('./theory/CompoundTheoryStrategy');
    exports.LeftSplitComplementaryStrategy = require('./theory/LeftSplitComplementaryStrategy');
    exports.MonochromeTheoryStrategy = require('./theory/MonochromeTheoryStrategy');
    exports.RightSplitComplementaryStrategy = require('./theory/RightSplitComplementaryStrategy');
    exports.SingleComplementStrategy = require('./theory/SingleComplementStrategy');
    exports.SplitComplementaryStrategy = require('./theory/SplitComplementaryStrategy');
    exports.TetradTheoryStrategy = require('./theory/TetradTheoryStrategy');
    exports.TriadTheoryStrategy = require('./theory/TriadTheoryStrategy');
    //for creating custom strategies
    exports.strategies = require('./theory/strategies');




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/color/theory.js
// module id = 4583
// module chunks = 14